import { z } from 'zod';

/** 給与形態・賞与形態一覧の URL 検索（勤務形態一覧と同形） */
export const PayrollSyntheticStructureListSearchSchema = z.object({
  lifecycleTab: z.enum(['all', 'draft', 'applied', 'archived']).default('applied'),
  countryCode: z.string().default('all'),
  pageSize: z.number().default(50),
  pageIndex: z.number().default(0)
});
export type PayrollSyntheticStructureListSearchParams = z.infer<typeof PayrollSyntheticStructureListSearchSchema>;